import React from 'react';
import LegalPage from './LegalPage';

const Pricing = () => (
  <LegalPage title="Pricing">
    <p>
      ContextJet AI provides custom-priced software, AI, automation, NLP, and
      IT consulting services.
    </p>
    <p>
      Because every project has different requirements, timelines,
      integrations, complexity, and support needs, we do not follow a fixed
      one-size-fits-all pricing model.
    </p>

    <h2>Our pricing is based on:</h2>
    <ul>
      <li>Project scope</li>
      <li>Technical complexity</li>
      <li>Estimated development effort</li>
      <li>Timeline and urgency</li>
      <li>Number of integrations</li>
      <li>AI model or API usage requirements</li>
      <li>Infrastructure and deployment requirements</li>
      <li>Support and maintenance needs</li>
      <li>Third-party tools or subscription costs, if applicable</li>
    </ul>

    <h2>Typical Engagement Types</h2>

    <h3>1. Fixed-Scope Projects</h3>
    <p>
      Suitable for clearly defined projects with agreed deliverables, timeline,
      and milestones.
    </p>

    <h3>2. Monthly Retainer</h3>
    <p>
      Suitable for ongoing software development, AI implementation, automation
      work, maintenance, and technical support.
    </p>

    <h3>3. Consulting Engagements</h3>
    <p>
      Suitable for strategy, architecture planning, technical audits, AI
      feasibility, product planning, or implementation guidance.
    </p>

    <h3>4. Custom Enterprise Work</h3>
    <p>
      Suitable for larger or more complex projects requiring custom workflows,
      integrations, security, deployment, or long-term support.
    </p>

    <h2>Payment Terms</h2>
    <p>Payment terms are shared in the proposal or invoice for each client engagement.</p>
    <p>Depending on the project, payments may be collected as:</p>
    <ul>
      <li>Advance payment</li>
      <li>Milestone-based payment</li>
      <li>Monthly retainer</li>
      <li>Final payment before delivery or deployment</li>
      <li>Custom payment schedule agreed in writing</li>
    </ul>

    <h2>International Payments</h2>
    <p>
      We accept payments from international clients through approved bank
      transfer and payment gateway methods. Payment instructions are shared
      through official invoices or written communication.
    </p>

    <h2>Request a Quote</h2>
    <p>To receive a quote, please contact us with your project requirements.</p>
    <ul>
      <li>Email: takeoff@contextjetai.services</li>
      <li>Website: https://www.contextjetai.services</li>
    </ul>
  </LegalPage>
);

export default Pricing;
